import React from 'react';
import { PdqOrderStatus } from 'components';

const PdqOrderMerchants = (props) => {
    return <PdqOrderStatus {...props} />;
};

export default PdqOrderMerchants;
